import { InboundDocumentJob } from "#/api/inbound-document-jobs.type";
import InboundDocumentJobCard from "./InboundDocumentJobCard";

type InboundDocumentJobListProps = {
  jobs: InboundDocumentJob[];
};

export function InboundDocumentJobList({ jobs }: InboundDocumentJobListProps) {
  return (
    <ul className="space-y-4">
      {jobs.map((job) => (
        <InboundDocumentJobCard key={job.id} job={job} />
      ))}
    </ul>
  );
}

export default InboundDocumentJobList;
